/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseNavigationSetting } from './DatabaseNavigationSetting';
import {
    DatabaseNavigationSettingFromJSON,
    DatabaseNavigationSettingFromJSONTyped,
    DatabaseNavigationSettingToJSON,
} from './DatabaseNavigationSetting';

/**
 * Navigationskonzept je Geraet. Getrennt in das LAYOUT (wo die Bedienung sitzt) und die INHALTE (was sie anbietet) — beim alten `interactionMode` war beides vermischt: die Varianten BUTTONS_LIGHT / BURGER_MENU_LIGHT waren nichts anderes als "dasselbe Layout, aber vier Knoepfe weniger".
 * @export
 * @interface DatabaseNavigationProperties
 */
export interface DatabaseNavigationProperties {
    /**
     * 
     * @type {DatabaseNavigationSetting}
     * @memberof DatabaseNavigationProperties
     */
    desktop?: DatabaseNavigationSetting;
    /**
     * 
     * @type {DatabaseNavigationSetting}
     * @memberof DatabaseNavigationProperties
     */
    tablet?: DatabaseNavigationSetting;
    /**
     * 
     * @type {DatabaseNavigationSetting}
     * @memberof DatabaseNavigationProperties
     */
    mobile?: DatabaseNavigationSetting;
}

/**
 * Check if a given object implements the DatabaseNavigationProperties interface.
 */
export function instanceOfDatabaseNavigationProperties(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNavigationPropertiesFromJSON(json: any): DatabaseNavigationProperties {
    return DatabaseNavigationPropertiesFromJSONTyped(json, false);
}

export function DatabaseNavigationPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNavigationProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desktop': !exists(json, 'desktop') ? undefined : DatabaseNavigationSettingFromJSON(json['desktop']),
        'tablet': !exists(json, 'tablet') ? undefined : DatabaseNavigationSettingFromJSON(json['tablet']),
        'mobile': !exists(json, 'mobile') ? undefined : DatabaseNavigationSettingFromJSON(json['mobile']),
    };
}

export function DatabaseNavigationPropertiesToJSON(value?: DatabaseNavigationProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desktop': DatabaseNavigationSettingToJSON(value.desktop),
        'tablet': DatabaseNavigationSettingToJSON(value.tablet),
        'mobile': DatabaseNavigationSettingToJSON(value.mobile),
    };
}

